// Must stay the first import: Sentry has to be initialized before any other module runs.
import './sentry';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';

import { GlobalError } from 'src/components/GlobalError';
import { DomainRedirect } from 'src/components/DomainRedirect';
import { ThemeProvider } from 'src/theme';

import ErrorFallback from 'src/components/ErrorFallback';
import MaintenancePage from 'src/components/MaintenancePage';

import App from './app/App';
import store from './store/storeSetup';

import './index.css';
import './assets/fonts/OpenSans-Regular.ttf';

const container = document.getElementById('root');
const root = createRoot(container);

const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

root.render(
  isMaintenanceMode ? (
    <MaintenancePage />
  ) : (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <React.StrictMode>
          <Router>
            <DomainRedirect>
              <ThemeProvider>
                <GlobalError />
                <App />
              </ThemeProvider>
            </DomainRedirect>
          </Router>
        </React.StrictMode>
      </Provider>
    </Sentry.ErrorBoundary>
  ),
);
